import shiftRequestDetailsStore from "../../store/store";
import { IBaseShiftEntity } from "sh-models";
import { mutatorAction } from "satcheljs";

export default mutatorAction('SET_SHIFT', function setShiftInStore(shift: IBaseShiftEntity) {
    if (shiftRequestDetailsStore) {
        shiftRequestDetailsStore.shift = shift;
    }
});
